import type { DealFixedRateLoanData } from '@src/types/OTC';
import { getOtcDealRateDisplayValue } from '@src/utils/OTC/otcDealDisplayUtils';
import { HStack, InlineFormattedNumber } from '@talos/kyoko';

export const FixedRateLoanDisplay = ({ instrumentData }: { instrumentData: DealFixedRateLoanData }) => {
  const displayValue = getOtcDealRateDisplayValue(instrumentData);
  if (!displayValue) {
    return <>-</>;
  }
  return (
    <HStack gap="spacing4" alignItems="center">
      <InlineFormattedNumber
        data-testid="instrument-inspector-section-field-value"
        number={displayValue.value}
        currency={displayValue.currency}
        background="backgroundBlotterTableRowHover"
      />
    </HStack>
  );
};
